import React, { useEffect } from 'react';

// assets

// services

// props

// components
import { ActionButton, Link, Stack, TagPicker } from '@fluentui/react';
import Label from '../../../typography/label';
import Text from '../../../typography/text';
import { IShipResourceShortProps } from '../../../../props/data/ships';
import ShipsService from '../../../../services/data/ships';
import { IVendorResourceShortProps } from '../../../../props/data/vendors';
import ShipForm from '../../../operationals/ships/general/form';
import PermissionsService from '../../../../services/permissions';
import { useStore } from '../../../../stores/root';

type ShipFieldProps = {
    vendor?: IVendorResourceShortProps;
    selected?: IShipResourceShortProps;
    options?: IShipResourceShortProps[];
    qs?: string[];
    label?: string;
    hideLabel?: boolean;
    required?: boolean;
    disabled?: boolean;
    allowCreate?: boolean;
    onChange(selected?: IShipResourceShortProps): void;
}

const ShipField: React.FC<ShipFieldProps> = (props: ShipFieldProps) => {
    const { user } = useStore();
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();
    const [selected, setSelected] = React.useState<IShipResourceShortProps | undefined>();

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    useEffect(() => {
    }, [props]);

    const _onSearchShip = async (keyword: string) => {
        try {
            if (props.options) {
                return props.options.map((item) => ({
                    key: item.id,
                    name: item.name,
                    metadata: item
                }));
            } else {
                const qs: string[] = props.qs || [];
                if (props.vendor) { qs.push(`vendor_id=${props.vendor.id}`) }
                if (keyword && keyword.trim() !== '') { qs.push(`search=${keyword}`) }

                const options = (await ShipsService.retrieve(qs.join("&"))).map((item) => ({
                    key: item.id,
                    name: item.name,
                    metadata: item
                }));

                return options;
            }
        } catch (error) {
            return [];
        }
    }

    return <Stack>
        {props.hideLabel ? null : <Label style={{padding: '3px 0px'}} size={'xsmall'} required={props.required}>{props.label || "Ship"}</Label>}
        {!selected ? <>
            <TagPicker
                disabled={props.disabled}
                selectedItems={[]}
                removeButtonAriaLabel='Remove'
                itemLimit={1}
                onItemSelected={(item: any) => {
                    const selected = item ? item.metadata : undefined;
                    props.onChange(selected);

                    return null;
                }}
                onRenderSuggestionsItem={(props: any) => {
                    const md = props.metadata as IShipResourceShortProps;

                    return <Stack styles={{ root: { padding: 5 }}} horizontalAlign='baseline'>
                        <Label size={'small'}>{md.name}</Label>
                        <Text size={'small'}>{md.vendor.name}</Text>
                    </Stack>;
                }}
                onResolveSuggestions={_onSearchShip}
                onEmptyResolveSuggestions={() => _onSearchShip('')}
            />
            {props.allowCreate && PermissionsService.hasPermission(['ships.create'], user.permissions) ? <Text size={'small'}>Cannot find ship? <Link onClick={() => {setActiveSurface('create')}}>Click here</Link> to create ship</Text> : null}
        </> : null}
        {selected ? <Stack styles={{ root: { padding: 8 } }} className={'card'} horizontal tokens={{ childrenGap: 20 }} horizontalAlign={'space-between'} verticalAlign='center'>
            <Stack>
                <Label size={'small'}>{selected.name}</Label>
                {selected.registrationNumber && props.vendor ? <Text size={'small'}>{selected.registrationNumber}</Text> : null}
                {!props.vendor ? <Text size={'small'}>{selected.vendor.name}</Text> : null}
            </Stack>
            {!props.disabled ? <ActionButton iconProps={{ iconName: "Delete" }} onClick={() => { props.onChange(); }} /> : null}
        </Stack> : null}
        {activeSurface === 'create' ? <ShipForm vendorId={props.vendor?.id} onDismissed={(refresh, ship) => {
            setActiveSurface(undefined);
            props.onChange(ship);
        }} /> : null}
    </Stack>;
};

export default ShipField;
